import { Clock, Home, Search, User } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const tabs = [
  { label: 'Accueil', to: '/', icon: Home, match: (path) => path === '/' },
  { label: 'Analyser', to: '/analyze', icon: Search, match: (path) => path.startsWith('/analyze') || path === '/results' || path === '/report' },
  { label: 'Historique', to: '/history', icon: Clock, match: (path) => path === '/history' },
  { label: 'Profil', to: '/profil', icon: User, match: (path) => path === '/profil' },
];

export default function Footer() {
  const { pathname } = useLocation();

  return (
    <nav className="fixed-shell bottom-0 h-16 bg-white border-t border-gray-200 rounded-t-2xl px-4 md:px-10 flex items-center justify-between z-40" aria-label="Navigation principale">
      {tabs.map(({ label, to, icon: Icon, match }) => {
        const active = match(pathname);
        return (
          <Link
            key={label}
            to={to}
            className="min-h-11 min-w-11 flex flex-col items-center justify-center gap-0.5 active:scale-95 transition-transform"
            aria-label={label}
            aria-current={active ? 'page' : undefined}
          >
            <span className={active ? 'px-4 py-1.5 rounded-xl bg-brand-navy text-white' : 'text-gray-700'}>
              <Icon className="w-5 h-5" strokeWidth={2.3} />
            </span>
            {active ? <span className="text-xs text-brand-navy font-medium">{label}</span> : null}
          </Link>
        );
      })}
    </nav>
  );
}
